"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _useTheme = _interopRequireDefault(require("@mui/material/styles/useTheme.js"));
var _createStyles = _interopRequireDefault(require("@mui/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Close = _interopRequireDefault(require("../icons/Close"));
var _Search = _interopRequireDefault(require("../icons/Search"));
var _DebouncedTextField = _interopRequireDefault(require("./DebouncedTextField"));
var _VoiceButton = _interopRequireDefault(require("./VoiceButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  container: {
    display: 'flex',
    borderRadius: 60,
    overflow: 'hidden',
    justifyContent: 'flex-end'
  },
  removeRadius: {
    borderRadius: 0
  },
  clickOpen: {
    ...theme.custom.rotateLeft
  },
  containerOpen: ({
    inputColor
  }) => ({
    background: inputColor || theme.palette.grayscale.lightest
  }),
  search: {
    verticalAlign: 'baseline',
    flexGrow: 1,
    [theme.breakpoints.down('md')]: {
      width: '70%'
    }
  },
  slideOut: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  smallButton: {
    padding: theme.spacing(1)
  },
  smallIcon: {
    fontSize: '18px'
  }
}));
/**
 * Collapsable search bar with voice mic that takes 100% width of parent container
 */
const SearchBar = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    collapsable = true,
    disabled,
    placeholder,
    onChange,
    onEnter,
    debounceInterval = 0,
    value: _value,
    height = 'normal',
    radius = true,
    className,
    iconColor = '#4e4e4e',
    inputColor,
    clearOnCollapse = false,
    InputProps,
    autoFocus,
    onEscape,
    AdditionalActions
  } = props;
  const [value, setValue] = (0, _react.useState)(_value || '');
  const [usedVoice, setUsedVoice] = (0, _react.useState)(false);
  const [isCollapsed, setIsCollapsed] = (0, _react.useState)(collapsable);
  const classes = useStyles({
    inputColor
  });
  const theme = (0, _useTheme.default)();
  const inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (clearOnCollapse && isCollapsed) {
      setValue('');
      if (onChange) onChange('');
    }
  }, [isCollapsed]);
  (0, _react.useEffect)(() => {
    if (collapsable !== isCollapsed) setIsCollapsed(collapsable);
  }, [collapsable]);
  (0, _react.useEffect)(() => {
    if (_value !== value) setValue(_value || '');
    if (usedVoice) setUsedVoice(false);
  }, [_value]);
  const toggleInput = () => {
    if (isCollapsed && inputRef.current) inputRef.current.focus();
    setIsCollapsed(!isCollapsed);
  };
  const onKeyPress = ({
    key,
    target
  }) => {
    if (key === 'Enter' && typeof onEnter === 'function') onEnter(target.value, usedVoice);
    if (key === 'Escape') {
      if (collapsable) setIsCollapsed(true);
      onEscape?.();
    }
  };
  const handleTextChange = text => {
    setValue(text);
    onChange?.(text);
  };
  const smHeight = height === 'small';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames.default)(classes.container, className, {
      [classes.containerOpen]: !isCollapsed,
      [classes.removeRadius]: !radius
    }),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: classes.slideOut,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        disabled: true,
        className: (0, _classnames.default)({
          [classes.smallButton]: smHeight
        }),
        size: "large",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Search.default, {
          htmlColor: theme.palette.background.topBar,
          className: smHeight ? classes.smallIcon : ''
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DebouncedTextField.default, {
        className: classes.search,
        debounceTime: debounceInterval,
        disabled: disabled || isCollapsed,
        InputProps: InputProps,
        inputRef: inputRef,
        onChange: handleTextChange,
        onKeyDown: onKeyPress,
        onFocus: e => {
          if (!autoFocus) e.target.select();
        },
        placeholder: placeholder || 'Search',
        ref: ref,
        value: value,
        autoFocus: autoFocus
      }), AdditionalActions && /*#__PURE__*/(0, _jsxRuntime.jsx)(AdditionalActions, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_VoiceButton.default, {
        className: (0, _classnames.default)({
          [classes.smallButton]: smHeight
        }),
        iconProps: smHeight ? {
          className: classes.smallIcon
        } : undefined,
        onClick: () => inputRef.current?.select(),
        onTextChange: val => {
          setUsedVoice(true);
          handleTextChange(val);
        }
      })]
    }), collapsable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      className: (0, _classnames.default)({
        [classes.clickOpen]: !isCollapsed,
        [classes.smallButton]: smHeight
      }),
      disabled: disabled,
      onClick: toggleInput,
      size: "large",
      children: isCollapsed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Search.default, {
        htmlColor: iconColor,
        className: smHeight ? classes.smallIcon : ''
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Close.default, {
        className: smHeight ? classes.smallIcon : ''
      })
    }) : null]
  });
});
var _default = exports.default = SearchBar;